export default __webpack_public_path__ + "00d44de6a39efb8639664daf88a42204.svg";